<template>
  <div class="login-form-wrap" :class="loginstatus">
    <template v-if="user">
      <div v-show="user">
        <div class="grid-x align-center">
          <Avatar :user="user" :size="125" class="cell shrink" />
        </div>
        <h3>Du är inloggad som {{ user.firstname }}</h3>
        <button v-show="user" class="button" @click="logout">
          Logga ut
        </button>
      </div>
    </template>

    <!-- <pre>fbRefused: {{ fbRefused }}

    </pre> -->

    <div v-show="!user" class="login-form">
      <template v-if="submitted">
        <EmailAnimation />
        <h2>Kolla din mail</h2>
        <h3>Vi har skickat ett mail till {{ username }}</h3>
      </template>

      <template v-else>
        <div class="error-message">
          <strong>Houston, we have a problem.</strong> Uppgifterna verkar inte
          stämma överens, försök igen!
        </div>

        <header>
          <svg xmlns="http://www.w3.org/2000/svg" width="57" height="64">
            <defs>
              <linearGradient
                id="astroGrad"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
                gradientTransform="rotate(30)">
                <!-- <stop offset="0%" style="stop-color:rgb(255,119,101);stop-opacity:1">
                 <animate attributeName="stop-color" values="rgb(255,119,101); rgb(255,119,101); rgb(255,119,101)" dur="4s" repeatCount="indefinite"></animate>
              </stop>
              <stop offset="100%" style="stop-color:rgb(100,188,178);stop-opacity:1">
                <animate attributeName="stop-color" values="rgb(100,188,178); rgb(255,119,101); rgb(100,188,178)" dur="4s" repeatCount="indefinite"></animate>
              </stop> -->
                <stop
                  offset="0%"
                  style="stop-color:rgb(100,188,178);stop-opacity:1">
                  <animate
                    attributeName="stop-color"
                    values="rgb(100,188,178); rgb(100,188,178); rgb(100,188,178)"
                    dur="4s"
                    repeatCount="indefinite" />
                </stop>
                <stop
                  offset="100%"
                  style="stop-color:rgb(255,119,101);stop-opacity:1">
                  <animate
                    attributeName="stop-color"
                    values="rgb(255,119,101); rgb(100,188,178); rgb(255,119,101)"
                    dur="4s"
                    repeatCount="indefinite" />
                </stop>
              </linearGradient>
            </defs>
            <path
              fill="url(#astroGrad)"
              fill-rule="evenodd"
              d="M36.863657 16.0000954c2.166661 0 4.041656.7916641 5.624987 2.3749943 1.58333 1.5833302 2.374994 3.4583257 2.374994 5.6249866v1.9999952c0 2.4999941-.624999 4.8333225-1.874996 6.9999833-1.249997 2.1666609-2.958327 3.8749908-5.124987 5.1249878-2.166661 1.249997-4.49999 1.8749955-6.999984 1.8749955h-3.99999c-2.499994 0-4.833323-.6249985-6.999984-1.8749955-2.16666-1.249997-3.87499-2.9583269-5.124987-5.1249878-1.249997-2.1666608-1.874996-4.4999892-1.874996-6.9999833v-1.9999952c0-2.1666609.791664-4.0416564 2.374994-5.6249866 1.583331-1.5833302 3.458326-2.3749943 5.624987-2.3749943h15.999962zm3.99999 9.9999761v-1.9999952c0-1.0833314-.395833-2.0208292-1.187497-2.8124933-.791664-.7916641-1.729162-1.1874972-2.812493-1.1874972H20.863695c-1.083331 0-2.020829.3958331-2.812493 1.1874972-.791664.7916641-1.187497 1.7291619-1.187497 2.8124933v1.9999952c0 2.7499935.979163 5.1041539 2.937493 7.0624832 1.958329 1.9583293 4.312489 2.937493 7.062483 2.937493h3.99999c2.749994 0 5.104154-.9791637 7.062483-2.937493 1.95833-1.9583293 2.937493-4.3124897 2.937493-7.0624832zm-15.999961-3.9999904l1.499996 4.4999892 4.499989 1.4999965-4.499989 1.4999964-1.499996 4.4999893-1.499997-4.4999893-4.499989-1.4999964 4.499989-1.4999965 1.499997-4.4999892zm13.999966 27.9999332c1.666662 0 3.083327.5833326 4.24999 1.7499958C44.280305 52.9166734 44.863638 54.3333379 44.863638 56v6.9999833c0 .2499994-.104166.4791649-.312499.6874984-.208334.2083334-.437499.3124992-.687499.3124992h-1.999995c-.249999 0-.479165-.1041658-.687498-.3124992-.208334-.2083335-.3125-.437499-.3125-.6874984V56c0-.5833326-.187499-1.0624975-.562498-1.4374966-.374999-.3749991-.854164-.5624986-1.437497-.5624986H18.8637c-.583333 0-1.062498.1874995-1.437497.5624986-.374999.3749991-.562498.854164-.562498 1.4374966v6.9999833c0 .2499994-.104166.4791649-.3125.6874984-.208333.2083334-.437499.3124992-.687498.3124992h-1.999995c-.25 0-.479165-.1041658-.687499-.3124992-.208333-.2083335-.312499-.437499-.312499-.6874984V56c0-1.6666621.583333-3.0833266 1.749996-4.2499899 1.166663-1.1666632 2.583328-1.7499958 4.24999-1.7499958h19.999952zM34.863662 56c.583332 0 1.062497.1874996 1.437496.5624987.374999.3749991.562499.854164.562499 1.4374965 0 .5833326-.1875 1.0624975-.562499 1.4374966-.374999.3749991-.854164.5624987-1.437496.5624987-.583333 0-1.062498-.1874996-1.437497-.5624987-.374999-.3749991-.562499-.854164-.562499-1.4374966 0-.5833325.1875-1.0624974.562499-1.4374965C33.801164 56.1874996 34.280329 56 34.863662 56zM22.86369 56c.583333 0 1.062498.1874996 1.437497.5624987.374999.3749991.562499.854164.562499 1.4374965v4.9999881c0 .2499994-.104166.4791649-.3125.6874984-.208333.2083334-.437499.3124992-.687498.3124992h-1.999995c-.25 0-.479165-.1041658-.687499-.3124992-.208333-.2083335-.312499-.437499-.312499-.6874984v-4.9999881c0-.5833325.1875-1.0624974.562499-1.4374965C21.801193 56.1874996 22.280358 56 22.86369 56zm22.874946-14.9999642c3.333326 1.249997 6.020819 3.2916581 8.062481 6.1249854 2.041661 2.8333272 3.062492 6.0416516 3.062492 9.624977v6.2499851c0 .2499994-.104166.4791649-.312499.6874984-.208333.2083334-.437499.3124992-.687498.3124992h-1.999996c-.249999 0-.479164-.1041658-.687498-.3124992-.208333-.2083335-.312499-.437499-.312499-.6874984v-6.2499851c0-3.1666585-1.062498-5.9374858-3.187493-8.3124802-2.124995-2.3749943-4.729154-3.8124909-7.812481-4.3124897-3.99999 2.5833278-8.333314 3.8749908-12.999969 3.8749908s-8.999979-1.291663-12.999969-3.8749908c-3.083327.4999988-5.687486 1.9374954-7.812481 4.3124897-2.124995 2.3749944-3.187493 5.1458217-3.187493 8.3124802v6.2499851c0 .2499994-.104166.4791649-.312499.6874984-.208333.2083334-.437499.3124992-.687498.3124992H1.86374c-.249999 0-.479165-.1041658-.687498-.3124992-.208333-.2083335-.312499-.437499-.312499-.6874984v-6.2499851c0-3.5833254 1.020831-6.7916498 3.062492-9.624977 2.041662-2.8333273 4.729155-4.8749884 8.062481-6.1249854-2.583328-2.4999941-4.499989-5.4999869-5.749986-8.9999786H4.863733c-.583332 0-1.062497-.1874995-1.437496-.5624986-.374999-.3749991-.562499-.854164-.562499-1.4374966V18.0000906c0-.5833326.1875-1.0624975.562499-1.4374966.374999-.3749991.854164-.5624986 1.437496-.5624986H6.23873c1.666662-4.7499887 4.562489-8.6041455 8.687479-11.5624725C19.051199 1.479296 23.697022.0001335 28.863676.0001335c5.166654 0 9.812477 1.4791625 13.937467 4.4374894 4.12499 2.958327 7.020817 6.8124838 8.687479 11.5624725h1.374997c.583332 0 1.062497.1874995 1.437496.5624986.374999.3749991.562499.854164.562499 1.4374966V30.000062c0 .5833326-.1875 1.0624975-.562499 1.4374966-.374999.3749991-.854164.5624986-1.437496.5624986h-1.374997c-1.249997 3.4999917-3.166658 6.4999845-5.749986 8.9999786zm-16.87496 2.9999928c3.583325 0 6.91665-.8958318 9.999976-2.6874936 3.083327-1.7916617 5.520821-4.2291559 7.312483-7.3124825 1.791661-3.0833267 2.687493-6.4166508 2.687493-9.9999762 0-3.5833254-.895832-6.9166495-2.687493-9.9999762-1.791662-3.0833266-4.229156-5.5208208-7.312483-7.3124825-3.083326-1.7916618-6.416651-2.6874936-9.999976-2.6874936-3.583325 0-6.91665.8958318-9.999976 2.6874936-3.083327 1.7916617-5.520821 4.2291559-7.312483 7.3124825-1.791661 3.0833267-2.687493 6.4166508-2.687493 9.9999762 0 3.5833254.895832 6.9166495 2.687493 9.9999762 1.791662 3.0833266 4.229156 5.5208208 7.312483 7.3124825 3.083326 1.7916618 6.416651 2.6874936 9.999976 2.6874936z" />
          </svg>
          <h1>
            <template>{{ $t('onboarding.login-title') }}</template>
          </h1>
          <h2>
            <template>{{ $t('onboarding.login-desc') }}</template>
          </h2>
        </header>

        <!-- Choose method -->
        <div class="login-box-wrap">

          <!-- Choose login method -->
          <form v-if="showForm == 'choose'">
            <h2>Hur vill du logga in?</h2>
            <button class="button button-submit facebook" @click.prevent="loginWithFB">Facebook</button>
            <div class="form-button-divider"><span>eller</span></div>
            <button class="button button-submit email" @click.prevent="showForm = 'email'">Epost</button>
          </form>

          <!-- Login with email -->
          <form v-if="showForm == 'email'" @submit.prevent="login">
            <FloatLabel>
              <input v-model="username"
                name="email"
                required
                type="text"
                :placeholder="$t('onboarding.email')"
                autocomplete="email">
            </FloatLabel>
            <FloatLabel>
              <input v-model="password"
                name="password"
                required
                type="password"
                :placeholder="$t('onboarding.password')"
                autocomplete="password">
            </FloatLabel>
            <button id="submit-login" type="submit" :disabled="loginstatus === 'loading'" class="button-submit secondary">Logga in</button>
          </form>

          <!-- Sign up -->
          <form v-if="showForm == 'register'" @submit.prevent="registerEmail">
            <h2>Registrera dig med</h2>
            <template v-if="!showEmail">
              <button class="button button-submit facebook" @click.prevent="loginWithFB">Facebook</button>
              <div class="form-button-divider"><span>eller</span></div>
            </template>
            <template v-if="showEmail">
                <FloatLabel>
                  <input
                    v-model="username"
                    name="email"
                    required
                    type="text"
                    :placeholder="$t('onboarding.email')"
                    autocomplete="email">
                </FloatLabel>
              <button id="submit-login" type="submit" :disabled="loginstatus === 'loading'" class="button-submit secondary">Fortsätt</button>
            </template>
            <template v-if="!showEmail">
                <button class="button-submit secondary email" @click.prevent="showEmail = true">Epost</button>
            </template>
          </form>

        <!-- Forgot Password -->
        <form v-if="showForm == 'forgot'" @submit.prevent="forgotPW">

          <h2>Glömt ditt lösenord?</h2>

          <FloatLabel>
            <input
              v-model="username"
              name="email"
              required
              type="text"
              :placeholder="$t('onboarding.email')"
              autocomplete="email">
          </FloatLabel>

          <button
            id="submit-login"
            type="submit"
            :disabled="loginstatus === 'loading'"
            class="button-submit secondary">
            Skicka nytt lösenord
          </button>
        </form>

        </div>


        <form
          v-if="loginstatus != 'success'" class="login"
          @submit.prevent="submitForm">
          <template v-if="action != 'register'">

          </template>

            <!-- Login -->
            <span v-if="showForm == 'register'" class="login-type-nav">
              Har du redan ett konto?
              <a href="/" :class="{active: ['choose', 'email'].includes(showForm)}" @click.prevent="showForm = 'choose'">Logga in här.</a>
              <!-- <template>{{ $t('onboarding.login') }}</template> -->
            </span>

            <!-- Register -->
            <span v-if="showForm == 'choose'" class="login-type-nav">
              Har du inget konto?
              <a href="/" :class="{active: showForm == 'register'}"
                @click.prevent="showForm = 'register';showEmail = false">Bli medlem här.</a>
              <!-- <template>{{ $t('onboarding.login') }}</template> -->
            </span>

            <!-- Forgot -->
            <span v-if="showForm == 'email'" class="login-type-nav">
              <a href="/" :class="{active: showForm == 'forgot'}"
                @click.prevent="showForm = 'forgot'">
                  <template>{{ $t('onboarding.forgot') }}</template>
                </a>
            </span>

            <!-- Back to login -->
            <span v-if="showForm == 'forgot'" class="login-type-nav">
              <a href="/" :class="{active: ['choose', 'email'].includes(showForm)}"
                @click.prevent="showForm = 'choose'">
                  Logga in
                </a>
            </span>

        </form>

      </template>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from '@/components/Avatar.vue'
import FloatLabel from '@/components/FloatLabels.vue'
import EmailAnimation from '@/components/EmailAnimation.vue'
// import FBButton from '@/components/FBButton.vue'
import store from '@/store'

import { facebookSDK } from '@/mixins/facebook-sdk.js'


export default {
  components: {
    Avatar,
    FloatLabel,
    EmailAnimation,
    // VFacebookLogin
    // VFBLoginScope
    // FBButton
  },
  mixins: [facebookSDK],
  data () {
    return {
      showEmail: false,
      showForm: 'choose',
      loginWithEmail: false,
      submitted: false,
      action: 'login',
      isReady: false,
      username: '',
      password: '',
      referer: 'Loginbox'
    }
  },

  computed: {
    ...mapGetters(['token', 'user', 'loginstatus', 'fbConnected', 'fbFirstName', 'fbSdkReady', 'fbRefused']),

    // ...mapState(['fbConnected', 'fbFirstName'])
  },
  watch: {
    fbRefused: {
      handler (fbRefused) {
        if (fbRefused) {
          // console.log('You refused FB')
          // console.log(this.showForm)
          // this.showForm = 'email'
        }
      }
    },
    user: {
      handler () {
        if (this.user) {
          this.username = ''
          this.password = ''
        }
      }
    }
  },

  methods: {
    // testStatus(){
    //   console.log(VFBLoginScope.data())
    // },
    testLogout () {
      this.$refs.fblogin.toggleLogin()
    },
    imconnected (val) {
      // console.log(val)
      // console.log('Im connected')
    },

    loginWithFB () {
      window.FB.login(function (response) {
        if (response.status == 'connected') {
          // We are connected to facebook
          store.commit('SET_FB_CONNETED', true)
          store.dispatch('loginFB', response.authResponse.accessToken)
        } else {
          store.commit('SET_FB_REFUSED', true)
          // console.log('INTE ANSLUTEN')
        }
      }, { scope: 'email' })
    },

    tryinglogin (val) {
      // console.log(val.status)
      // console.log(val.authResponse.accessToken)
      // console.log(val.authResponse.signedRequest)

      this.$store
        .dispatch('loginFB', val.authResponse.accessToken)
        .then((response) => {
          // console.log('From LoginBox.vue')
          // console.log(response);
          // this.$store.dispatch('updateMe')
          // this.$store.dispatch('getFilters')
          // this.$store.dispatch('getMyAds')
          // this.$router.push('/')
          // this.$store.dispatch('updateMe').then(response => {
          // console.log(response)
          // })
        })
        .catch(error => {
          throw error;
                //  Sentry.captureException(error);

          // There was an error
        })
    },
    // join(){
    //   console.log('Joina');
    //   Vue.FB.getLoginStatus(function(response) {
    //       console.log(response.status)
    //     })
    // },
    loginFB () {
      //   Vue.FB.api('/me', dude => {
      //     console.log(dude)
      //   })
      //   Vue.FB.getLoginStatus(function(response) {
      //     console.log(response.status)
      //   })
    },
    onFBReady: function () {
      this.isFBReady = true
    },
    // remove() {
    //   FB.api('/me/permissions', 'delete', function(response) {
    //     console.log(response) // true
    //   })
    // },

    // onSignInSuccess(response) {
    //   FB.api('/me', dude => {
    //     console.log(`Good to see you, ${dude.name}.`)
    //     FB.getLoginStatus(function(response) {
    //       console.log(response)
    //     })
    //   })
    // },
    onSignInError (error) {
      // console.log('OH NOES', error)
                       Sentry.captureException(error);

    },
    logout () {
      this.$store.dispatch('logout')
      // .then(() => {
      // this.$router.push({ name: 'login'})

      // })
    },

    registerEmail () {
      // console.log('registering with email', this.username)

      this.$store.dispatch('registerEmail', this.username, this.referer).then(res => {
        // console.log(res)
        // this.submitted = true
        this.$router.push({ name: 'create-ad' })
      }).catch(err => {
  Sentry.captureException(err);
        // this.$store.dispatch('forgotPW', this.username)
        this.$store.dispatch('resetpw', this.username).then(response => {
        // console.log(response)
          this.submitted = true
        }).catch(err =>{
            Sentry.captureException(err);
        })
      })
    },
    forgotPW () {
      this.$store.dispatch('resetpw', this.username).then(response => {
        // console.log(response)
        this.submitted = true
      }).catch(err=>{
          Sentry.captureException(err);

      })
    },

    submitForm () {
      if (this.action == 'login') {
        this.login()
      }

      if (this.action == 'forgot') {
        this.forgotPW()
      }
    },
    login () {
      const { username, password } = this

      this.$store
        .dispatch('login', { username, password })
        .then(() => {
          // this.$store.dispatch('updateMe')
          // this.$store.dispatch('getFilters')
          // this.$store.dispatch('getMyAds')
          // this.$router.push('/')
          // this.$store.dispatch('updateMe').then(response => {
          // console.log(response)
          // })
        })




        .catch(error => {






        // throw new Error(error)
          // throw error;
  Sentry.captureException(error);
          // There was an error
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.facebook{
    background: url('/img/facebook-f-circle.svg');
    background-repeat: no-repeat;
    background-size: 31px;
    background-position-y: 50%;
    background-position-x: 16px;
    background-color: #5975b1;
}
.facebook:hover{
  background-color:#607dba;
  /* border: 2px #8b9dc3; */
}

.email{
    background: url('/img/email-circle.svg');
    background-color: #64BCB2;
    background-repeat: no-repeat;
    background-size: 31px;
    background-position-y: 50%;
    background-position-x: 16px;
}
.email:hover{
  background-color:#75CBC1;
  /* border: 2px #8b9dc3; */
}

.button-frameless.active{
  color:#5E5E5E;
  background-color:#f7f7f7;
  border-radius: 5px;
}

.forgot-my-password-wrap{
  position:absolute; bottom:40px; left:0px; right:0px; text-align:center; display:block; width:100%; text-align:center;
}
.forgot-my-password{
  cursor:pointer; color:#5E5E5E; font-size:16px;
  &:hover{color:#252525;}
}

</style>
